import { Controller } from "@hotwired/stimulus";

const getPathName = (url: string) => new URL(url).pathname;

const urlMatches = (currentPath: string, item: HTMLLinkElement) => {
  const { matchType } = item.dataset;
  const itemPathName = getPathName(item.href);
  if (matchType === "exact") {
    return currentPath == itemPathName;
  }

  return (
    item.href !== "#" &&
    !item.href.endsWith(`${currentPath}#`) &&
    currentPath.indexOf(getPathName(item.href)) >= 0
  );
};

// Overlay
// Show
const showOverlay = (workspace: boolean) => {
  let overlay = document.querySelector<HTMLDivElement>(".overlay");
  if (overlay) return overlay;

  document.body.classList.add("overlay-show");

  overlay = document.createElement("div");
  if (workspace) {
    overlay.setAttribute("class", "overlay overlay_workspace");
  } else {
    overlay.setAttribute("class", "overlay");
  }

  document.body.appendChild(overlay);
  overlay.classList.add("active");

  return overlay;
};

// Hide
const hideOverlay = () => {
  const overlayToRemove = document.querySelector(".overlay");

  if (!overlayToRemove) return;

  document.body.classList.remove("overlay-show");

  overlayToRemove.classList.remove("active");
  document.body.removeChild(overlayToRemove);
};

export default class extends Controller {
  static urlMatches() {
    throw new Error("Method not implemented.");
  }
  static targets = ["item", "parentMenu"];

  declare readonly itemTargets: HTMLLinkElement[];
  declare readonly hasItemTarget: boolean;

  declare readonly parentMenuTargets: HTMLLinkElement[];
  declare readonly hasParentMenuTarget: boolean;

  initialize() {
    this.handleVisit = this.handleVisit.bind(this);

    document.documentElement.addEventListener(
      "turbo:before-visit",
      this.hideMenuDetail.bind(this)
    );
  }

  connect() {
    document.documentElement.addEventListener(
      "turbo:visit",
      this.handleVisit as EventListener
    );
    this.setActiveMenuItem(window.location.href);
  }

  disconnect() {
    if (document) {
      document.documentElement.removeEventListener(
        "turbo:visit",
        this.handleVisit as EventListener
      );
    }
  }

  handleVisit(evt: CustomEvent<{ url: string }>) {
    this.setActiveMenuItem(evt.detail.url);
  }

  setActiveMenuItem(url: string) {
    const currentPath = getPathName(url);
    this.removeAllActiveClass();

    this.itemTargets.forEach((item) => {
      if (urlMatches(currentPath, item)) {
        item.classList.add("active");

        const detailMenu = item.closest<HTMLDivElement>(".menu-detail");
        if (!detailMenu) return;

        const mainMenu = document.querySelector(
          `.menu-items .link[data-target="[data-menu=\\"${detailMenu.dataset.menu}\\"]"]`
        );
        if (mainMenu) {
          mainMenu.classList.add("active");
        }
      } else {
        item.classList.remove("active");
      }
    });
  }

  removeAllActiveClass() {
    this.parentMenuTargets.forEach((menu) => {
      menu.classList.remove("active");
    });
  }

  hideMenuDetail() {
    this.element.querySelectorAll(".menu-detail.open").forEach((menuDetail) => {
      hideOverlay();

      if (!this.element.classList.contains("menu-wide")) {
        menuDetail.classList.remove("open");
      }
    });
  }

  openMenu(event: MouseEvent & { target: HTMLDivElement }) {
    event.preventDefault();
    if (!event.target) return;

    const menuLink = event.target.closest<HTMLLinkElement>(".link");
    if (!menuLink) return;
    const menu = menuLink.dataset.target;
    if (!menu) return;
    const selectedMenu = this.element.querySelector(menu);

    if (selectedMenu && !this.element.classList.contains("menu-wide")) {
      const isSelectedMenuOpen = selectedMenu.classList.contains("open");

      this.hideMenuDetail();

      if (selectedMenu && !isSelectedMenuOpen) {
        showOverlay(true).addEventListener(
          "click",
          this.hideMenuDetail.bind(this)
        );
        selectedMenu.classList.add("open");
      } else {
        hideOverlay();
      }
    }
  }
}
